import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button } from "react-bootstrap";
import { NotificationManager } from "react-notifications";

import Header from "../header";
import { setSideMenu } from "../Sidemenu/actions";
import { getUserDetails } from "../../utils/verifyUser";
import { getMediaGallery, mediaRename, deleteMedia, uploadMedia, assetsMap } from "./actions";
import Loader from "../sharedComponents/Loader";
import NoData from "../sharedComponents/NoData";
import MediaCard from "../sharedComponents/MediaCard";
import SharedModal from "../sharedComponents/Modal";
import MediaDropZone from "../sharedComponents/DropZone";
import upload from "../../assets/images/modal-icon.png";
import { useTranslation } from "react-i18next";

const AudioGallery = ({
	history,
	menu,
	setSideMenu,
	getMediaGallery,
	gallery,
	mediaRename,
	deleteMedia,
	uploadMedia,
	responseCount,
	assetsMap,
}) => {
	const { t } = useTranslation();
	const [loader, setLoader] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const [show, setShow] = useState(null);
	const [audioList, setAudioList] = useState(gallery && gallery.length > 0 ? gallery : []);
	const [isEditing, setIsEditing] = useState(false);
	const [isAudioGallery] = useState(true);
	const [deleteItem, setDeleteItem] = useState(null);
	const [audioUploadList, setAudioUploadList] = useState([]);
	const [audioUrl, setAudioUrl] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [index, setIndex] = useState(1);
	const [selectAll, setSelectAll] = useState(false);
	const [deleteAll, setDeleteAll] = useState(false);
	const [deleteItemList, setDeleteItemList] = useState([]);
	const [fileTimeOut, setFileTimeOut] = useState(null);
	const [searchTimeout, setSearchTimeout] = useState(null);

	const selectAllRef = useRef(null);

	const userRole = getUserDetails() && getUserDetails().role && getUserDetails().role.description;

	useEffect(() => {
		const location = history.location.pathname.split("/");
		setSideMenu({
			menu: [{ title: location[2] }],
			language: "",
		});
	}, [history, setSideMenu]);

	useEffect(() => {
		setLoader(true);
		searchTerm &&
			getMediaGallery(`Audio&SortBy=LastModified&SortDirection=Desc&Size=40&FileName=${searchTerm}`).then((res) => {
				if (res.response.records.length > 0) {
					setLoader(false);
					setAudioList(res.response.records);
				} else {
					setLoader(false);
					setAudioList([]);
				}
			});
	}, [searchTerm, getMediaGallery]);

	useEffect(() => {
		setLoader(true);
		getMediaGallery("Audio&SortBy=LastModified&SortDirection=Desc&Size=40").then((res) => {
			if (res && res.response && res.response.records) {
				setLoader(false);
				setAudioList([...res.response.records]);
			}
		});
	}, [getMediaGallery, setLoader]);

	const handleChange = (e) => {
		const value = e.target.value;
		setLoader(true);
		clearTimeout(searchTimeout);
		const timeOut = setTimeout(() => {
			if (value && value.length > 0) {
				setSearchTerm(value);
				setLoader(false);
			} else {
				setSearchTerm("");
				getMediaGallery("audio&SortBy=LastModified&Size=40&SortDirection=Desc").then((res) => {
					if (res && res.response && res.response.records) {
						setLoader(false);
						setAudioList([...res.response.records]);
					}
				});
			}
		}, 500);
		setSearchTimeout(timeOut);
	};

	const handleImageRename = (oldName, newName, id) => {
		setLoader(true);
		mediaRename({
			oldFileName: oldName,
			newFileName: "xmlassets/audio/" + newName,
		}).then((res) => {
			if (res.statusCode === 200) {
				setIsEditing(false);
				setLoader(false);
				setAudioList(
					audioList.map((item) =>
						item.filePath === id
							? {
									...item,
									fileName: newName,
									fileKey: "xmlassets/audio/" + newName,
									filePath: "https://biblingo.s3.amazonaws.com/xmlassets/audio/" + newName,
							  }
							: item
					)
				);
				NotificationManager.success(t("helpers.gallery.renamesuccess"), "", 3000);
			} else {
				NotificationManager.error(res.response.message, "", 2000);
				setLoader(false);
			}
			setIsEditing(false);
		});
	};
	const handleClose = () => setShow(null);

	const handleUploadClose = () => {
		setShow(null);
		setUploadFailedList([]);
		failedEntry = [];
	};

	const handleDelete = (item) => {
		setDeleteItem(item);
		setShow("ConfirmationModal");
	};

	const multipleDelete = () => {
		setLoader(true);
		setShow(null);
		if (deleteItemList && deleteItemList.length > 0) {
			const deleteFileKey = deleteItemList.map((item) => item.fileKey);
			deleteMedia(deleteAll ? { deleteAll: true } : { fileKeys: deleteFileKey }).then((res) => {
				if (res) {
					if (res.statusCode === 200) {
						assetsMap().then((response) => {
							if (deleteAll) {
								NotificationManager.success(t("helpers.audio.deletedsuccess"), "", 3000);
								setLoader(false);
								setAudioList([]);
							} else {
								getMediaGallery("Audio&SortBy=LastModified&SortDirection=Desc&Size=40").then((res) => {
									if (res && res.response && res.response.records) {
										setAudioList([...res.response.records]);
										setLoader(false);
										NotificationManager.success(t("helpers.audio.deletedsuccess"), "", 3000);
									}
								});
							}
						});
					} else {
						NotificationManager.error(res.response.message, "", 2000);
						setLoader(false);
					}
					setDeleteItemList([]);
				}
			});
		}
	};

	const deleteAudio = () => {
		setLoader(true);
		const deleteFileKey = audioList.filter((item) => (item.filePath === deleteItem ? item : null));
		deleteFileKey[0] &&
			deleteFileKey[0].fileKey &&
			deleteMedia({ fileKeys: [deleteFileKey[0].fileKey] }).then((res) => {
				if (res) {
					if (res.statusCode === 200) {
						assetsMap().then((data) => {
							getMediaGallery("audio&SortBy=LastModified&SortDirection=Desc&Size=40").then((res) => {
								if (res && res.response && res.response.records) {
									setAudioList([...res.response.records]);
									setLoader(false);
									NotificationManager.success(t("helpers.audio.deletedsuccess"), "", 3000);
								}
							});
						});
					} else {
						NotificationManager.error(res.response.message, "", 2000);
						setLoader(false);
					}
					setShow(null);
					setDeleteItem("");
				}
			});
	};

	const [uploadFailedList, setUploadFailedList] = useState([]);
	let failedEntry = [];

	const handleAudioPlayer = (value) => {
		setShow("AudioModal");
		setAudioUrl(value);
	};

	const handleSelectAll = () => {
		if (selectAllRef.current.checked === true) {
			setSelectAll(true);
			setDeleteItemList([...audioList]);
		} else {
			setSelectAll(false);
			setDeleteItemList([]);
		}
	};

	const handleClearSelection = () => {
		setDeleteAll(false);
		setSelectAll(false);
		setDeleteItemList([]);
		selectAllRef.current.checked = false;
	};

	const uploadFile = (i) => {
		if (i < audioUploadList.length) {
			setLoader(true);
			const formData = new FormData();
			formData.append("uploadedFile", audioUploadList[i]);
			uploadMedia(formData).then((res) => {
				if (res.statusCode === 200) {
					uploadFile(i + 1);
				} else if (res.statusCode === 709) {
					failedEntry.push(audioUploadList[i]);
					setUploadFailedList([...failedEntry]);
					uploadFile(i + 1);
				} else {
					setLoader(false);
					NotificationManager.error(
						res.statusCode === 704 ? t("helpers.gallery.filelimit") : t("helpers.utils.notification.error"),
						"",
						3000
					);
				}
			});
		} else if (i >= audioUploadList.length) {
			failedEntry && failedEntry.length > 0 && setShow("uploadFailed");
			assetsMap();
			getMediaGallery("audio&SortBy=LastModified&SortDirection=Desc&size=40").then((res) => {
				if (res && res.response && res.response.records) {
					setLoader(false);
					setAudioList([...res.response.records]);
					failedEntry.length === 0 && NotificationManager.success(t("helpers.utils.uploadsuccesful"), "", 3000);
				}
			});
		}
	};

	const handleUpload = (e) => {
		setLoader(true);
		uploadFile(0);
		setShow(null);
		setAudioUploadList([]);
	};

	const handleCloseModal = () => {
		setShow(null);
		setSelectAll(false);
	};

	const renderUpdatedList = () =>
		getMediaGallery(`Audio&SortBy=LastModified&SortDirection=Desc&Index=${index}`).then((res) => {
			if (res.response.hasNext === true) {
				setIsLoading(false);
				setLoader(false);
				setIndex(index + 1);
				res && res.response && res.response.records && setAudioList([...audioList, ...res.response.records]);
			} else {
				setLoader(false);
				setIndex(1);
			}
		});

	const confirmationModalBody = () => (
		<React.Fragment>
			{t("helpers.utils.deleteprompt")}
			<b>
				{deleteItemList && deleteItemList.length > 0
					? deleteAll
						? ` ${responseCount} files?`
						: deleteItemList.length > 1
						? ` ${deleteItemList.length} files?`
						: ` ${deleteItemList.length} file?`
					: ` ${deleteItem && deleteItem.split("/").pop()}?`}
			</b>
		</React.Fragment>
	);

	const confirmationModalFooter = () => (
		<React.Fragment>
			<button className="btn-cancel" onClick={() => handleCloseModal()}>
				{t("helpers.utils.no")}
			</button>
			<button
				className="btn-upload"
				onClick={() => (deleteItemList && deleteItemList.length > 0 ? multipleDelete() : deleteAudio())}>
				{t("helpers.utils.yes")}
			</button>
		</React.Fragment>
	);
	const uploadFailedModal = () => {
		return (
			<React.Fragment>
				<div className="upload-failed d-flex justify-content-center ">
					<img src={upload} alt="upload" />
				</div>
				<h3 className="upload-modal-text mb-2 text-center">{t("helpers.gallery.fileexists")}</h3>
				<ul className="list-unstyled text-center">
					{uploadFailedList &&
						uploadFailedList.length > 0 &&
						uploadFailedList.map((item, index) => <li key={index}>{item.name}</li>)}
				</ul>
			</React.Fragment>
		);
	};
	const uploadModalHead = () => <span>{t("helpers.gallery.uploadaudioonly")}</span>;

	const uploadModalBody = () => (
		<div className="px-3">
			<div className="upload-container rounded">
				<MediaDropZone
					uploadFormat=".wav,.mp3"
					fileSize={20971520}
					maxFiles={30}
					inputWithFilesContent={"+"}
					submitButtonContent={null}
					isAudioGallery={isAudioGallery}
					uploadedFileList={audioUploadList}
					fileTimeOut={fileTimeOut}
					setFileTimeOut={setFileTimeOut}
					dropzoneClass="videoUpload"
					setLoader={setLoader}
					setUploadedFileList={setAudioUploadList}
				/>
			</div>
		</div>
	);

	const uploadModalFooter = () => (
		<div>
			<button className="btn-cancel" onClick={() => setShow(null)}>
				{t("helpers.utils.cancel")}
			</button>
			<button
				className="btn-upload"
				onClick={handleUpload}
				disabled={audioUploadList && audioUploadList.length > 0 ? false : true}>
				{t("helpers.utils.upload")}
			</button>
		</div>
	);

	const videoModalBody = () => (
		<div className="d-flex justify-content-center">
			<audio controls controlsList="nodownload" src={audioUrl}></audio>
		</div>
	);

	return (
		<div
			className="empty"
			onScroll={(e) => {
				if (e && e.nativeEvent && e.nativeEvent.target) {
					const scrollHeight = e.nativeEvent.target.scrollHeight;
					const offsetHeight = e.nativeEvent.target.offsetHeight;
					const scrollTop = e.nativeEvent.target.scrollTop;

					if (scrollHeight - offsetHeight - 50 < scrollTop) {
						if (!isLoading && show === null) {
							setLoader(true);
							renderUpdatedList();
							setIsLoading(true);
						}
					}
				}
			}}>
			<Header menu={menu} head={"Audio"} history={history} />

			<div className="d-flex justify-content-between px-4 sub-header-wrapper">
				{loader && <Loader />}
				<div className="position-relative search-container">
					<i className="icon icon-search" />
					<input
						className="media-search"
						type="text"
						placeholder={t("languagelearning.fluencydrills.searchhere")}
						onChange={(e) => handleChange(e)}
					/>
				</div>
				<div className="d-flex align-items-center">
					{deleteItemList && deleteItemList.length > 0 && (
						<div
							className={`position-relative align-items-center ${
								userRole !== "Administrator" ? "d-none" : "d-flex "
							}`}>
							<label className="custom-checkbox mr-2">
								<span className="pl-4">{t("helpers.utils.selectall")}</span>
								<input type="checkbox" ref={selectAllRef} onChange={() => handleSelectAll()} />
								<span className="tickmark"></span>
							</label>

							<button className="mr-2 delete-icon" onClick={() => setShow("ConfirmationModal")}>
								<i className="icon icon-delete1"></i>
							</button>
						</div>
					)}
					{userRole === "Administrator" && (
						<Button className="upload-btn" onClick={() => setShow("uploadModal")}>
							<i className="icon icon-upload mr-2" />
							Upload
						</Button>
					)}
				</div>
			</div>
			{selectAll && (
				<div className="px-4 mt-4">
					<div className="delete-all-container text-center">
						{deleteAll ? (
							<div>
								{`${responseCount}` + `${t("helpers.audioswereselected")}`}
								<b className="select-all-phrase pl-2" onClick={() => handleClearSelection()}>
									{t("helpers.utils.clearselection")}
								</b>
							</div>
						) : (
							<div>
								
								{audioList && audioList.length} {t("helpers.audios.areselected")}
								<b className="select-all-phrase pl-2" onClick={() => setDeleteAll(true)}>
									{t("helpers.audio.selectallaudios")}
								</b>
							</div>
						)}
					</div>
				</div>
			)}
			<div className="px-4 mt-4">
				{audioList && audioList.length > 0 ? (
					<div className="row media-gallery">
						{audioList.map((item) => (
							<div className="col-lg-3 col-md-6 col-sm-12" key={item.filePath}>
								{item.filePath && (
									<MediaCard
										cardData={item}
										isEditing={isEditing}
										isAudioGallery={isAudioGallery}
										handleImageRename={handleImageRename}
										setIsEditing={setIsEditing}
										setDeleteItem={handleDelete}
										handleAudioPlayer={handleAudioPlayer}
										setDeleteItemList={setDeleteItemList}
										deleteItemList={deleteItemList}
										selectAll={selectAll}
									/>
								)}
							</div>
						))}
					</div>
				) : (
					<NoData />
				)}
			</div>
			<SharedModal
				show={show === "uploadModal" ? true : false}
				handleClose={handleClose}
				modalHead={uploadModalHead()}
				modalBody={uploadModalBody()}
				modalFooter={uploadModalFooter()}
				centered="true"
				modalClass="gallery"
			/>
			<SharedModal
				show={show === "ConfirmationModal" ? true : false}
				handleClose={handleClose}
				modalBody={confirmationModalBody()}
				modalFooter={confirmationModalFooter()}
				modalClass="confirm-modal"
			/>
			<SharedModal
				show={show === "AudioModal" ? true : false}
				handleClose={handleClose}
				modalBody={videoModalBody()}
				modalClass="audio-modal"
			/>
			<SharedModal
				show={show === "uploadFailed" ? true : false}
				handleClose={handleUploadClose}
				modalBody={uploadFailedModal()}
				modalClass=""
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	menu: state.sideMenu.menu,
	language: state.sideMenu.language,
	gallery: state.mediaGallery.gallery,
	responseCount: state.mediaGallery.count,
});

const mapDispatchToProps = {
	setSideMenu,
	getMediaGallery,
	mediaRename,
	deleteMedia,
	uploadMedia,
	assetsMap,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AudioGallery));
